import React from 'react'

import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'
import { Skeleton, usePAWStore } from '@rewardops/ui'
import { getComplementColor } from '@rewardops/utils'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const ComparisonTable: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api, tenant } = useApi()
  const { date } = usePAWStore((state) => state)

  const { data: participations, isLoading } =
    api.pawDashboards.getInteractionsGroupedByTeam.useQuery({
      ...date,
      rankByCurrency: ['POINTS'],
    })

  const gradientColor = getComplementColor(
    tenant?.customStyling?.primaryColor ?? '#FFFFFF',
  )

  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Comparison'}
      </h2>
      {isLoading ? (
        <Skeleton className="h-[250px] w-full" />
      ) : (
        <Card className="overflow-visible">
          <CardContent className="p-6">
            {participations?.map((participation: any) => (
              <div
                key={participation?.teamId}
                className="flex items-center gap-4 p-2"
              >
                <div className="w-32 text-sm font-semibold capitalize">
                  {participation?.teamName}
                </div>
                <div className="mx-8 h-3 flex-1 rounded-full bg-muted">
                  <div
                    className={`h-3 rounded-full bg-gradient-to-r from-tenant-primary-color 
                      to-[var(--gradient-to)] transition-all`}
                    style={
                      {
                        width: `${participation.participationRate}%`,
                        '--gradient-to': gradientColor,
                      } as React.CSSProperties
                    }
                  />
                </div>
                <div className="text-sm font-semibold">
                  {participation.participationRate}%
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      )}
    </section>
  )
}
